export const breakClips = [
	{
		id: "br-01",
		caption: "Cypher · Atlanta",
		year: "2024",
		location: "Atlanta, GA",
		date: "Mar 2024",
		context:
			"Open cypher at the Red Bull BC One qualifier. Three rounds deep against the local heads.",
	},
	{
		id: "br-02",
		caption: "Practice session",
		year: "2023",
		location: "GT Campus, ATL",
		date: "Oct 2023",
		context:
			"Late night crew session in the CRC. Working footwork fundamentals on hardwood.",
	},
	{
		id: "br-03",
		caption: "Jam, 7-to-Smoke",
		year: "2024",
		location: "Brooklyn, NY",
		date: "Jun 2024",
		context:
			"7-to-Smoke format at a Brooklyn warehouse jam. One of the best nights of the year.",
	},
	{
		id: "br-04",
		caption: "Outdoor session",
		year: "2023",
		location: "Piedmont Park, ATL",
		date: "Aug 2023",
		context:
			"Spontaneous sunset session on concrete. Cardboard, no agenda.",
	},
];

export const currentlyPlaying = [
	{
		id: "g-now-1",
		title: "Cyberpunk: 2077",
		platform: "PC",
		status: "70%",
	},
	{
		id: "g-now-2",
		title: "Megaman: Battle Network Legacy Collection 1 + 2",
		platform: "Switch",
		status: "Game 1",
	},
];

export const favoriteGames = [
	{
		id: "g-elden",
		title: "Elden Ring",
		platform: "PC",
		progress: 86,
		note: "All Endings",
	},
	{
		id: "g-smash",
		title: "Smash Ultimate",
		platform: "Switch",
		progress: 92,
		note: "Top 8 Local",
	},
	{
		id: "g-hades",
		title: "Hades II",
		platform: "PC",
		progress: 64,
		note: "Early Access",
	},
	{
		id: "g-balatro",
		title: "Balatro",
		platform: "PC",
		progress: 47,
		note: "Gold Stake",
	},
];

export const photos = [
	{
		id: "p-01",
		caption: "Ektar 100 · Portrait",
		film: "Kodak Ektar 100",
	},
	{
		id: "p-02",
		caption: "Cinestill 800T · Night",
		film: "Cinestill 800T",
	},
	{
		id: "p-03",
		caption: "Portra 400 · Daylight",
		film: "Kodak Portra 400",
	},
	{
		id: "p-04",
		caption: "HP5 · Street",
		film: "Ilford HP5",
	},
	{
		id: "p-05",
		caption: "Portra 800 · Indoors",
		film: "Kodak Portra 800",
	},
	{
		id: "p-06",
		caption: "Tri-X · Cypher",
		film: "Kodak Tri-X 400",
	},
	{
		id: "p-07",
		caption: "Gold 200 · Travel",
		film: "Kodak Gold 200",
	},
];
